export const aspectRatioValues: Record<string, number> = {
  '16:9': round(100 / (16 / 9), 2),
  '282:145': round(100 / (282 / 145), 2),
  '147:212': round(100 / (147 / 212), 2),
  '21:9': round(100 / (21 / 9), 2),
  '7:10': round(100 / (7 / 10), 2),
  '7:6': round(100 / (7 / 6), 2),
  '2:3': round(100 / (2 / 3), 2),
};

export type AspectRatio = (typeof aspectRatios)[keyof typeof aspectRatios];

// Complex aspect ratios exported for reuseability
export const aspectRatios = {
  default: '16:9',
  wide: '282:145',
  poster: '7:10',
  dialog: '21:9',
  r7x6: '7:6',
  r2x3: '2:3',
} as const;

export const mapToAspectRatio: (aspectRatio?: string) => AspectRatio = aspectRatio => {
  if (!aspectRatio) {
    return aspectRatios.default;
  }
  switch (aspectRatio) {
    case '16:9':
      return aspectRatios.default;
    case '282:145':
      return aspectRatios.wide;
    case '147:212':
      return aspectRatios.poster;
    case '7:10':
      return aspectRatios.poster;
    case '21:9':
      return aspectRatios.dialog;
  }
  return aspectRatios.default;
};

function round(number: number, decimals = 4) {
  return parseFloat(number.toFixed(decimals));
}
